export const clusterUtterances = {
  numOfClusters: {
    presence: { allowEmpty: false, message: "is required" },
    numericality: {
      greaterThan: 0,
      lessThanOrEqualTo: 2000
    }
  },
  tenant: {
    presence: { allowEmpty: false, message: "is required" },
    length: {
      minimum: 2,
      maximum: 99
    },
    type: "string"
  },
  fromDate: {
    presence: { allowEmpty: false, message: "is required" }
  },
  toDate: {
    presence: { allowEmpty: false, message: "is required" }
  }
};

export const allUtterances = {
  tenant: {
    presence: { allowEmpty: false, message: "is required" },
    length: {
      minimum: 2,
      maximum: 99
    },
    type: "string"
  },
  fromDate: {
    presence: { allowEmpty: false, message: "is required" }
  },
  toDate: {
    presence: { allowEmpty: false, message: "is required" }
  }
};
